export default "__VITE_ASSET__dEz$iEtC__"